import IVRCreate from './Create'
import IVRUpdate from './Update'
import IVRDetails from './Details'
import IVRGet from './Get'

export {
    IVRCreate,
    IVRUpdate,
    IVRDetails,
    IVRGet,
}